// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__YoGQH","arrow":"style_arrow__Y09Wi","left":"style_left__kloek"};